var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Dompurify from 'dompurify';
import React, { memo } from 'react';
const purify = Dompurify(window);
purify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener');
    }
});
export const SanitizedHtml = memo((_a) => {
    var { as: Component = 'div', html } = _a, rest = __rest(_a, ["as", "html"]);
    const santized = purify.sanitize(html, { ADD_ATTR: ['target'] });
    return (React.createElement(Component, Object.assign({}, rest, { 
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: santized
        } })));
});
